import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [ ProgressSpinnerModule, CommonModule ]
})
export class SpinnerComponent implements OnInit {

  @Input() isLoading: boolean | null = false;

  constructor() { }

  ngOnInit(): void {
  }

}
